exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.not-found {\n  padding: 2rem 4rem;\n  border-radius: 1rem;\n  max-height: 50vh;\n  width: 60vw;\n  margin-top: 5rem;\n}\n@media (max-width: 440px){\n.not-found {\n    padding: 0.5rem 1rem;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-29415b98","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/pages/Page404.vue
// module id = 1286
// module chunks = 2